import styled, { css } from 'styled-components'
import { FunctionComponent } from 'react'
import { mobileCSS } from '@measures/responsive'
import PrimaryButton from '@components/Buttons/Primary'

interface LoginOverlayContainerProps {
  desktopPlaceholderImage?: string
  mobilePlaceholderImage?: string
}

interface LoginOverlayProps {
  text?: string
  buttonText?: string
  desktopPlaceholderImage?: string
  mobilePlaceholderImage?: string
  onClick: () => void
}

const LoginOverlayContainer = styled.div<LoginOverlayContainerProps>`
  ${({ desktopPlaceholderImage, mobilePlaceholderImage }) => {
    return css`
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 360px;
      background: url(${desktopPlaceholderImage}) repeat-y;
      background-size: 100% 100%;

      ${mobileCSS(css`
        background: url(${mobilePlaceholderImage}) repeat-y;
        background-size: 100% 100%;
      `)}
    `
  }}
`

const LoginOverlayTextWrapper = styled.div`
  max-width: 200px;
  max-height: 200px;
  text-align: center;
`

const LoginOverlay: FunctionComponent<LoginOverlayProps> = ({
  text,
  buttonText,
  desktopPlaceholderImage,
  mobilePlaceholderImage,
  onClick,
}) => (
  <LoginOverlayContainer
    desktopPlaceholderImage={desktopPlaceholderImage}
    mobilePlaceholderImage={mobilePlaceholderImage}>
    <LoginOverlayTextWrapper>
      <p>{text}</p>
      <PrimaryButton size="small" onClick={onClick}>
        {buttonText}
      </PrimaryButton>
    </LoginOverlayTextWrapper>
  </LoginOverlayContainer>
)

export default LoginOverlay
